module.exports = __webpack_public_path__ + "media/video.359e2cc1.mp4";